import React, { useState, useCallback } from "react";
import { Chips, ChipData } from "../Chips/Chips";
import { EventsList } from "../EventList/EventsList";
import { useAppSelector } from "../../hooks/redux";
import { Event } from "../../types";
import styles from "./SummaryModes.module.css";
import { Webcam } from "../../types";
// import CarIcon from "../icons/car.svg?react";
// import ClearChipIcon from "../icons/clearChip.svg?react";
// import FireIcon from "../icons/fire.svg?react";
// Импорт новых иконок для чипсов
import DpsChipIconLight from "../icons/chips/light/dps.svg?react";
import ClearChipIconLight from "../icons/chips/light/clear.svg?react";
import DtpChipIconLight from "../icons/chips/light/dtp.svg?react";
import WebcamIconLight from "../icons/chips/light/webcam.svg?react";

import DpsChipIconDark from "../icons/chips/dark/dps.svg?react";
import ClearChipIconDark from "../icons/chips/dark/clear.svg?react";
import DtpChipIconDark from "../icons/chips/dark/dtp.svg?react";
import WebcamIconDark from "../icons/chips/dark/webcam.svg?react";

import { useTheme } from "@/hooks/useTheme";
import { WebcamViewer } from "../WebcamViewer/WebcamViewer";
interface SummaryModesProps {
  onModeSelect: (modeId: string) => void;
  onZoomChange: (direction: "in" | "out") => void;
  onWebcamSelect?: (webcam: Webcam) => void;
  onLocationClarificationRequest?: (data: {
    event: Event;
    title: string;
    coordinates: [number, number];
  }) => void;
}

export const SummaryModes: React.FC<SummaryModesProps> = ({
  onModeSelect,
  // onWebcamSelect,
  onLocationClarificationRequest,
}) => {
  const [selectedChip, setSelectedChip] = useState<string>("dps");
  const { events, webcams } = useAppSelector((state) => state.map);
  const [selectedWebcamInSummary, setSelectedWebcamInSummary] =
    useState<Webcam | null>(null);
  const { theme } = useTheme();
  const handleLocationClarification = useCallback(
    (data: { event: Event; title: string; coordinates: [number, number] }) => {
      console.log("🎯 SummaryModes: Передаем запрос уточнения локации выше");
      onLocationClarificationRequest?.(data);
    },
    [onLocationClarificationRequest]
  );

  // const handleWebcamSelect = useCallback(
  //   (webcam: Webcam) => {
  //     onWebcamSelect?.(webcam);
  //   },
  //   [onWebcamSelect]
  // );
  const handleWebcamSelect = useCallback((webcam: Webcam) => {
    setSelectedWebcamInSummary(webcam); // Заменить на локальное состояние
  }, []);

  const handleChipClick = useCallback(
    (chipId: string) => {
      setSelectedChip(chipId);
      onModeSelect(chipId);
    },
    [onModeSelect]
  );

  const chips: ChipData[] = [
    {
      id: "dps",
      icon: theme === "dark" ? <DpsChipIconDark /> : <DpsChipIconLight />,
      text: "ДПС",
    },
    {
      id: "clean",
      icon: theme === "dark" ? <ClearChipIconDark /> : <ClearChipIconLight />,
      text: "Чисто",
    },
    {
      id: "accident",
      icon: theme === "dark" ? <DtpChipIconDark /> : <DtpChipIconLight />,
      text: "ДТП",
    },
    {
      id: "webcams",
      icon: theme === "dark" ? <WebcamIconDark /> : <WebcamIconLight />,
      text: "Камеры",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.stickyHeader}>
        <div className={styles.header}>
          <h1 className={styles.title}>ДПС-Контроль</h1>
        </div>
        <div className={styles.chipsContainer}>
          <Chips
            chips={chips}
            selectedChip={selectedChip}
            onChipClick={handleChipClick}
          />
        </div>
      </div>

      <div className={styles.eventsContainer}>
        {selectedWebcamInSummary ? (
          <WebcamViewer
            webcam={selectedWebcamInSummary}
            onBack={() => setSelectedWebcamInSummary(null)}
          />
        ) : (
          <EventsList
            events={events}
            webcams={webcams}
            selectedType={selectedChip}
            onLocationClarificationRequest={handleLocationClarification}
            onWebcamSelect={handleWebcamSelect}
          />
        )}
      </div>
    </div>
  );
};
